import React from 'react'
import { Link } from 'newComponents'
import MarketoForm from '../../../components/MarketoForm.js'
import './styles.scss'

const BlogCtaBanner = ({ text }) => (
  <section className="blog-cta-banner">
    <div className="new-container">
      <div className="blog-cta-banner-text">
        {text || 'Want to be notified about new stories? Sign up to receive updates.'}
      </div>
      <div className="blog-cta-banner-ctas">
        <MarketoForm formId="1079" />
        {/* <input type="text-area" placeholder="Enter your work email" className="blog-cta-banner-input"/>
          <Link to="#" className="blog-cta-banner-button">
            SUBSCRIBE
          </Link> */}
      </div>
    </div>
  </section>
)
export default BlogCtaBanner
